import { postRequestMall } from './request/request';
// 游戏列表
export const apiGameList = function (params) {
  return postRequestMall('/game/list', params);
};

// 游戏区服列表
export const apiGameServerList = function (params) {
  return postRequestMall('/game/role/serverList', params);
};

// 获取支付列表
export const apiGetPayList = function (params) {
  return postRequestMall('/pay/list', params, false, false);
};

// 再来一单
export const apiHandleRepay = function (params) {
  return postRequestMall('/order/rePay', params, false, false);
};

// 检查商品状态和数量
export const apiCheckGoodsStatus = function (params) {
  return postRequestMall('/order/skuCheck', params, false, true);
};

// 领取免费礼包
export const apiDirectGift = function (params) {
  return postRequestMall('/order/directGift', params, false, false);
};

// 绑定邮箱手机号/ 获取邮箱验证码 不传verifyCode表示获取验证码
export const apiEmailBind = function (params) {
  return postRequestMall('/game/role/emailBind', params, false, true);
};

// 授权验证
export const apiOpyVerify = function (params) {
  return postRequestMall('order/optVerify', params, false, true);
};

// 游戏初始化配置接口
export const apiGameInit = function (params) {
  return postRequestMall('/game/init', params, false, true);
};

// 限时返利详情
export const apiGameAwardInfo = function (params) {
  return postRequestMall('/game/awardInfo', params, false, true);
};

// 领取限时返利奖励
export const apiGameReceiveAward = function (params) {
  return postRequestMall('/game/receiveAward', params, true, true);
};

// 获取首页游戏配置
export const apiGetGameHomeConfig = function () {
  return postRequestMall('/game/gatherList', {}, false, true);
};

// 获取角色列表（摸鱼社内使用 国内）
export const apiGameRoles = function (params) {
  return postRequestMall('/game/role/roles', params, false, true);
};

// 拉取小号列表（国内）
export const apiGameSubList = function (params) {
  return postRequestMall('/game/role/roleLogin', params, false, true);
};

// 根据IP获取国家(海外接口)
export const apiGameCountry = function () {
  return postRequestMall('/game/role/ipRegion', {});
};

// 获取当前游戏配置了哪些地区的支付方式
export const apiGameGetPayRegions = function (params) {
  return postRequestMall('/pay/regions', params);
};